module.exports = __webpack_public_path__ + "static-portal/img/news14-1.2b37b25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news14-1.png
// module id = 58y1
// module chunks = 4